"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SCRIPT_URL = 'https://production-assets.codepen.io/assets/embed/ei.js';
var CodepenEmbedScriptTagBuilder = /** @class */ (function () {
    function CodepenEmbedScriptTagBuilder() {
        this.src = SCRIPT_URL;
        this.isAsync = false;
        this.onload = null;
        this.onerror = null;
    }
    CodepenEmbedScriptTagBuilder.prototype.withSrc = function (src) {
        this.src = src;
        return this;
    };
    CodepenEmbedScriptTagBuilder.prototype.setAsync = function (isAsync) {
        this.isAsync = isAsync;
        return this;
    };
    CodepenEmbedScriptTagBuilder.prototype.withOnLoadHandler = function (onload) {
        this.onload = onload;
        return this;
    };
    CodepenEmbedScriptTagBuilder.prototype.withOnErrorHandler = function (onerror) {
        this.onerror = onerror;
        return this;
    };
    CodepenEmbedScriptTagBuilder.prototype.appendTo = function (containerElement, createScriptTag) {
        if (createScriptTag === void 0) { createScriptTag = createDefaultScriptTag; }
        var script = createScriptTag();
        script.src = this.src;
        script.async = this.isAsync;
        script.onload = this.onload;
        script.onerror = this.onerror;
        containerElement.appendChild(script);
    };
    return CodepenEmbedScriptTagBuilder;
}());
function createDefaultScriptTag() {
    return document.createElement('script');
}
exports.default = CodepenEmbedScriptTagBuilder;
//# sourceMappingURL=CodepenEmbedScriptTagBuilder.js.map